import {XMarkIcon ,ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../animation/LoadingSpinner';

const RepackagingPopup = ({closeModal ,handleRepackage,isDisabled ,loading}) => {

  const { t } = useTranslation();

  return (
    <>
      <div className="fixed inset-0 z-[99] flex items-center justify-center w-full bg-black bg-opacity-20"
        
      >
      </div>
        <div className="fixed z-[999] w-[95%] md:w-[800px] m-auto p-4 bg-yellow-50 border  rounded-md shadow-lg 
        top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black"
        >
    {
      loading ?
        <LoadingSpinner />
        :
        <>
              <h3 className="flex items-center justify-center gap-2 mb-2 text-lg font-bold text-center text-black md:text-2xl">
              <ExclamationTriangleIcon className="w-6 h-6 text-red-600" />
              {t("RepackagingConfirmation.title")}
            </h3>
            <button
              onClick={closeModal}
              className="absolute text-2xl font-bold duration-300 top-4 right-2 hover:text-red-500"
            >
              <XMarkIcon class="h-6 w-6" />
            </button>
            <p className="mt-2 text-sm lg:text-sm">{t("RepackagingConfirmation.subtitle")}</p>
            <ul className="flex flex-col gap-1 mb-5 text-xs leading-relaxed list-disc list-outside lg:text-sm ps-5">
              <li className="list-none"></li>
              <li>{t("RepackagingConfirmation.step1")}</li>
              <li>{t("RepackagingConfirmation.step2")}</li>
              <li>{t("RepackagingConfirmation.step3")}</li>
              <li>{t("RepackagingConfirmation.step4")}</li>
              <li>{t("RepackagingConfirmation.step5")}</li>
              <li>{t("RepackagingConfirmation.step6")}</li>
              <li>{t("RepackagingConfirmation.step7")}</li>
              <li>{t("RepackagingConfirmation.step8")}</li>
              <li>{t("RepackagingConfirmation.step9")}</li>
            </ul>

            {/* Submit & Cancel */}
            <div className="flex items-center my-2 justify-evenly">
              <button
                onClick={closeModal}
                className={`z-0 inline-flex items-center rounded min-w-[25%] justify-center px-4 py-2 text-base text-black transition duration-300 ease-in-out transform bg-gray-300 hover:bg-gray-400 rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap  `}
              >
                {t('cancel')}
              </button>
                
                
              <button
                onClick={handleRepackage}
                // ref={buttonRef}
                disabled={isDisabled} 
                className={`z-0 inline-flex items-center rounded min-w-[25%] justify-center px-4 py-2 text-base text-black transition duration-300 ease-in-out transform bg-custom-yellow rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap ${isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-custom-yellow hover:bg-custom-yellow'}`}
              >
                {t('RepackagingConfirmation.confirm')}
              </button>
            </div>
              {isDisabled && 
                <p className="w-full my-2 text-xs text-center text-red-500 lg:text-sm">
                {t("NoProductsSelected.message")}
                </p>
              }
        </>
    }
    </div>
    </>
  );
};

export default RepackagingPopup;
